import { DocumentConfirmation, DocumentVariable } from '../common/types/types';
import ZahtjeviService from '../service/ZahtjeviService';

export const documentConfirm = (documentId: string | number, documentVariables: DocumentVariable[], postFunction: () => void) => {
  const mappedArray: { [key: string]: string | number | null } = {};
  documentVariables.forEach((item) => {
    mappedArray[item.name] = item.value;
  });

  const requestData: DocumentConfirmation = {
    ID: documentId,
    Name: mappedArray['Name'],
    CompanyName: mappedArray['CompanyName'],
    SupplierName: mappedArray['SupplierName'],
    InvoiceGroup: mappedArray['InvoiceGroup'],
    CompanyVAT: mappedArray['CompanyVAT'],
    InvoiceNumber: mappedArray['InvoiceNumber'],
    InvoiceDate: mappedArray['InvoiceDate'],
    InvoiceDueDate: mappedArray['InvoiceDueDate'],
    InvoiceSubtotal: Number(mappedArray['InvoiceSubtotal']),
    InvoiceTotal: Number(mappedArray['InvoiceTotal']),
    InvoiceCurrency: mappedArray['InvoiceCurrency'],
    ProcessID: mappedArray['ProcessID'],
    InvoiceComment: mappedArray['InvoiceComment'],
  };

  ZahtjeviService.confirmDocument(requestData).then((response) => {
    postFunction();
  });
};
